if(!customElements.get('faq-search')) {
  class faqSearchForm extends HTMLElement {
    constructor() {
      super();
      this.form                   = this.querySelector('form');
      this.input                  = this.querySelector('input[type="text"]');
      this.liItems                = document.querySelectorAll(".accordion-section-faq");
      this.searchHeader           = document.querySelector(".section-faq-inner__header");
      this.searchTerm             = document.querySelector(".js-search-term");
      this.searchContent          = document.querySelector('.section-faq-inner__wrapper');
      this.faqMain                = document.querySelector('.section-faq-main__body');
      this.accordions             = document.querySelector('.section-faq-inner__content');
      this.searchFormInnerInput   = document.querySelector('.section-faq-inner__content .search-faq input');
      this.asideSearchWrapper     = document.querySelector('.section-faq-inner__widget--search');
      this.hero                   = document.querySelector('.hero-faq');
    }

    toggle() {
      this.filter                 = this.input.value.toUpperCase();
      this.inputValue             = this.input.value;
    }

    cloneValue() {
      const searchForms = document.querySelectorAll(".js-faq-search");

      searchForms.forEach(searchForm => {
        if (searchForm != this.form) {
          const formInput = searchForm.querySelector('input[type="text"]');

          formInput.value = this.input.value
        };
      })
    }

    filterQuestions() {
      this.hero.classList.add('title-only');

      var resultsCount = 0;

      this.liItems.forEach(liItem => {
        const a = liItem.querySelector('.accordion-section-faq__text');
        const txtValue = a.textContent || a.innerText;

        if (txtValue.toUpperCase().indexOf(this.filter) > -1) {
          liItem.style.display = 'block';
          resultsCount++
        } else {
          liItem.style.display = 'none';
        }
      });

      this.searchHeader.classList.remove('hidden');
      this.searchContent.classList.remove('hidden');
      this.faqMain.classList.add('hidden');
      this.searchTerm.textContent = this.inputValue

      if (this.classList.contains('faq-search--secondary')) {
        this.asideSearchWrapper.classList.add('hidden');
      };

      this.searchFormInnerInput.focus();

      const windowWidth = window.innerWidth

      if (windowWidth < 767) {
        scrollToElement(document.body, this.accordions.offsetTop - 100);
        this.accordions.style.display = 'block'
      };
    }

    connectedCallback() {
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();

        this.toggle();
        this.cloneValue();
        this.filterQuestions();
      });

    }
  }

  customElements.define('faq-search', faqSearchForm);
}

function scrollToElement(element, to) {
  scroll({
    top: to,
    behavior: "smooth"
  });
}
